import { ApiDispatch } from "actions/apiDispatch";
import {
  LOC_CREATE_APPLICATION_FAILURE,
  LOC_CREATE_APPLICATION_REQUEST,
  LOC_CREATE_APPLICATION_SUCCESS,
  LOC_CREATE_CUSTOMER_FAILURE,
  LOC_CREATE_CUSTOMER_REQUEST,
  LOC_CREATE_CUSTOMER_SUCCESS,
  LOC_FINANCING_NEEDS_FAILURE,
  LOC_FINANCING_NEEDS_REQUEST,
  LOC_FINANCING_NEEDS_SUCCESS,
  LOC_GET_APPLICATION_FAILURE,
  LOC_GET_APPLICATION_REQUEST,
  LOC_GET_APPLICATION_SUCCESS,
  LOC_GET_BROKER_FAILURE,
  LOC_GET_BROKER_REQUEST,
  LOC_GET_BROKER_SUCCESS,
  LOC_GET_CUSTOMER_DETAILS_FAILURE,
  LOC_GET_CUSTOMER_DETAILS_REQUEST,
  LOC_GET_CUSTOMER_DETAILS_SUCCESS,
  LOC_GET_FILES_FAILURE,
  LOC_GET_FILES_REQUEST,
  LOC_GET_FILES_SUCCESS,
  LOC_REMOVE_ITEM_AT_PATH,
  LOC_RESET_STATE,
  LOC_CLEAR_APPLICATION_DATA,
  LOC_SELECT_BROKER,
  LOC_SELECT_MANAGER,
  LOC_SET_ITEM_AT_PATH,
  LOC_SUBMIT_APPLICATION_FAILURE,
  LOC_SUBMIT_APPLICATION_REQUEST,
  LOC_SUBMIT_APPLICATION_SUCCESS,
  LOC_UPDATE_BDM_FAILURE,
  LOC_UPDATE_BDM_REQUEST,
  LOC_UPDATE_BDM_SUCCESS,
  LOC_UPDATE_CUSTOMER_ADDRESS_DETAILS,
  LOC_UPDATE_CUSTOMER_FAILURE,
  LOC_UPDATE_CUSTOMER_REQUEST,
  LOC_UPDATE_CUSTOMER_SUCCESS,
  LOC_UPDATE_OFFICE_HOLDERS_FAILURE,
  LOC_UPDATE_OFFICE_HOLDERS_REQUEST,
  LOC_UPDATE_OFFICE_HOLDERS_SUCCESS,
  LOC_UPLOAD_FILE_FAILURE,
  LOC_UPLOAD_FILE_REQUEST,
  LOC_UPLOAD_FILE_SUCCESS,
  CALL_API,
} from "actions/types";
import { Dispatch } from "redux";
import {
  Manager,
  RemoveItemAtPathPayload,
  UpdateAddressAtPathPayload,
  UpdateItemAtPathPayload,
  User,
} from "redux-models/reduxStateTypes";

/**
 * @route /users/{userId}/afapplications/{applicationId}
 * @method GET
 * @desc gets a specific af application
 * @param {string} userId
 * @param {string} applicationId
 */
export const getLocApplication = (
  userId: string,
  applicationId: string
) => async (dispatch: ApiDispatch) => {
  await dispatch({
    [CALL_API]: {
      endpoint: `/v1/users/${userId}/locapplications/${applicationId}`,
      method: "GET",
      types: [
        LOC_GET_APPLICATION_REQUEST,
        LOC_GET_APPLICATION_SUCCESS,
        LOC_GET_APPLICATION_FAILURE,
      ],
    },
  });
};

/**
 *
 * @param {object} formData
 * @param {string} userId
 * @param {string} applicationId
 * @desc adds an quote from the global state
 */
export const uploadLocFile = (
  formData: object,
  userId: string,
  applicationId: string
) => async (dispatch: ApiDispatch) => {
  const res = await dispatch({
    [CALL_API]: {
      endpoint: `/v1/users/${userId}/applications/${applicationId}/documents`,
      method: "POST",
      body: formData,
      types: [
        LOC_UPLOAD_FILE_REQUEST,
        LOC_UPLOAD_FILE_SUCCESS,
        LOC_UPLOAD_FILE_FAILURE,
      ],
      cancellable: true,
    },
  });

  return { success: res?.type === LOC_UPLOAD_FILE_SUCCESS };
};

/**
 * @route /users/{userId}/afapplications/{applicationId}
 * @method POST
 * @desc gets a specific af application
 * @param {string} userId
 * @param {string} applicationId
 */
export const submitLocApplication = ({
  userId,
  applicationId,
}: {
  userId: string;
  applicationId: string;
}) => async (dispatch: ApiDispatch) => {
  const res = await dispatch({
    [CALL_API]: {
      endpoint: `/v1/users/${userId}/locapplications/${applicationId}/submit`,
      method: "PUT",
      types: [
        LOC_SUBMIT_APPLICATION_REQUEST,
        LOC_SUBMIT_APPLICATION_SUCCESS,
        LOC_SUBMIT_APPLICATION_FAILURE,
      ],
    },
  });
  return { success: res?.type === LOC_SUBMIT_APPLICATION_SUCCESS };
};

/**
 *
 * @param {string} userId
 * @param {string} applicationId
 * @desc gets documents for an application
 */
export const getLocApplicationFiles = (
  userId: string,
  applicationId: string
) => async (dispatch: ApiDispatch) => {
  dispatch({
    [CALL_API]: {
      endpoint: `/v1/users/${userId}/applications/${applicationId}/documents`,
      method: "GET",
      types: [
        LOC_GET_FILES_REQUEST,
        LOC_GET_FILES_SUCCESS,
        LOC_GET_FILES_FAILURE,
      ],
      cancellable: true,
    },
  });
};

/**
 * @param {string} customerId
 * @param {string} userId
 */
export const getCustomerDetailsLoc = ({
  userId,
  customerId,
}: {
  userId: string;
  customerId: string;
}) => {
  return async (dispatch: ApiDispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint: `/v1/users/${userId}/customers/${customerId}`,
        method: "GET",
        types: [
          LOC_GET_CUSTOMER_DETAILS_REQUEST,
          LOC_GET_CUSTOMER_DETAILS_SUCCESS,
          LOC_GET_CUSTOMER_DETAILS_FAILURE,
        ],
      },
    });
  };
};

/**
 * @param {string} customerId
 * @param {string} userId
 */
export const createCustomerLoc = ({
  userId,
  formData,
}: {
  userId: string;
  formData: any;
}) => async (dispatch: ApiDispatch) => {
  const res = await dispatch({
    [CALL_API]: {
      endpoint: `/v1/users/${userId}/customers`,
      method: "POST",
      body: formData,
      types: [
        LOC_CREATE_CUSTOMER_REQUEST,
        LOC_CREATE_CUSTOMER_SUCCESS,
        LOC_CREATE_CUSTOMER_FAILURE,
      ],
    },
  });

  const success = res?.type === LOC_CREATE_CUSTOMER_SUCCESS;
  return { success, customerId: res?.payload?.id };
};

export const updateCustomerLoc = ({
  userId,
  formData,
  customerId,
}: {
  userId: string;
  formData: any;
  customerId: string;
}) => async (dispatch: ApiDispatch) => {
  const res = await dispatch({
    [CALL_API]: {
      endpoint: `/v1/users/${userId}/customers/${customerId}`,
      method: "PUT",
      body: formData,
      types: [
        LOC_UPDATE_CUSTOMER_REQUEST,
        LOC_UPDATE_CUSTOMER_SUCCESS,
        LOC_UPDATE_CUSTOMER_FAILURE,
      ],
    },
  });
  const success = res?.type === LOC_UPDATE_CUSTOMER_SUCCESS;
  return { success, customerId };
};

/**
 * @route /v1/users/userId
 * @method GET
 * @param broker
 */
export const getBrokerLoc = ({ brokerId }: { brokerId: string }) => async (
  dispatch: ApiDispatch
) => {
  await dispatch({
    [CALL_API]: {
      endpoint: `/v1/users/${brokerId}`,
      method: "GET",
      types: [
        LOC_GET_BROKER_REQUEST,
        LOC_GET_BROKER_SUCCESS,
        LOC_GET_BROKER_FAILURE,
      ],
    },
  });
};

export const selectBrokerLoc = (broker: User | null) => async (
  dispatch: ApiDispatch
) =>
  dispatch({
    type: LOC_SELECT_BROKER,
    payload: broker,
  });

export const selectManagerLoc = (manager: Manager | null) => async (
  dispatch: ApiDispatch
) =>
  dispatch({
    type: LOC_SELECT_MANAGER,
    payload: manager,
  });

export const updateOfficeHoldersLoc = ({
  brokerId,
  customerId,
  applicationId,
  formData,
  managerId,
}: {
  brokerId: string;
  customerId: string;
  applicationId?: string;
  formData: any;
  managerId: string | null | undefined;
}) => async (dispatch: ApiDispatch) => {
  const updateRes = await dispatch({
    [CALL_API]: {
      endpoint: `/v1/users/${brokerId}/customers/${customerId}/officeholders`,
      method: "PUT",
      body: formData,
      types: [
        LOC_UPDATE_OFFICE_HOLDERS_REQUEST,
        LOC_UPDATE_OFFICE_HOLDERS_SUCCESS,
        LOC_UPDATE_OFFICE_HOLDERS_FAILURE,
      ],
    },
  });

  if (updateRes?.type === LOC_UPDATE_OFFICE_HOLDERS_SUCCESS) {
    if (!applicationId) {
      const createRes = await dispatch({
        [CALL_API]: {
          endpoint: `/v1/users/${brokerId}/locapplications`,
          method: "POST",
          body: {
            customerId: customerId,
            authorizationCheck: true,
            managerId: managerId,
          },
          types: [
            LOC_CREATE_APPLICATION_REQUEST,
            LOC_CREATE_APPLICATION_SUCCESS,
            LOC_CREATE_APPLICATION_FAILURE,
          ],
        },
      });
      // Update BDM id here, new a new endpoint updateApplicationBDM
      const success = createRes?.type === LOC_CREATE_APPLICATION_SUCCESS;
      applicationId = createRes?.payload?.id;

      return { success, applicationId };
    } else {
      await dispatch({
        [CALL_API]: {
          endpoint: `/v1/users/${brokerId}/locapplications/${applicationId}/bdm`,
          method: "PUT",
          body: {
            managerId: managerId,
          },
          types: [
            LOC_UPDATE_BDM_REQUEST,
            LOC_UPDATE_BDM_SUCCESS,
            LOC_UPDATE_BDM_FAILURE,
          ],
        },
      });
    }
  }

  return {
    success: updateRes?.type === LOC_UPDATE_OFFICE_HOLDERS_SUCCESS,
    applicationId,
  };
};

/**
 *
 * @route /v1/users/userId/afapplications/applicationId/financing
 * @method PUT
 */
export const updateFinancingApplicationLoc = ({
  brokerId,
  applicationId,
  financingNeed,
  financingAmount,
  averageMonthlySales,
  bankStatementBrokerFlowId,
  additionalComments,
}: {
  brokerId: string;
  applicationId: string;
  financingNeed: string;
  financingAmount: number;
  averageMonthlySales: number;
  bankStatementBrokerFlowId: string | undefined;
  additionalComments: string | undefined;
}) => async (dispatch: ApiDispatch) => {
  const res = await dispatch({
    [CALL_API]: {
      endpoint: `/v1/users/${brokerId}/locapplications/${applicationId}/financing`,
      method: "PUT",
      body: {
        financingNeed,
        financingAmount,
        averageMonthlySales,
        bankStatementBrokerFlowId,
        additionalComments,
      },
      types: [
        LOC_FINANCING_NEEDS_REQUEST,
        LOC_FINANCING_NEEDS_SUCCESS,
        LOC_FINANCING_NEEDS_FAILURE,
      ],
    },
  });

  return { success: res?.type === LOC_FINANCING_NEEDS_SUCCESS };
};

export const updateItemAtPathLoc = (
  pathAndValues: UpdateItemAtPathPayload
) => async (dispatch: Dispatch<any>) =>
  dispatch({
    type: LOC_SET_ITEM_AT_PATH,
    payload: pathAndValues,
  });

export const updateAddressAtPathLoc = (
  addressAndPath: UpdateAddressAtPathPayload
) => async (dispatch: Dispatch<any>) =>
  dispatch({
    type: LOC_UPDATE_CUSTOMER_ADDRESS_DETAILS,
    payload: addressAndPath,
  });

export const removeItemAtPathLoc = (payload: RemoveItemAtPathPayload) => async (
  dispatch: Dispatch<any>
) =>
  dispatch({
    type: LOC_REMOVE_ITEM_AT_PATH,
    payload,
  });

export const resetLineOfCreditState = () => async (dispatch: ApiDispatch) =>
  dispatch({
    type: LOC_RESET_STATE,
  });

export const clearLineOfCreditApplicationData = () => async (
  dispatch: ApiDispatch
) =>
  dispatch({
    type: LOC_CLEAR_APPLICATION_DATA,
  });
